import React from "react";

import classNames from "classnames";
import { Table } from "react-bootstrap";

import { UmpireRatingsProps } from "../types/umpire";

import { selectSetting } from "../../../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";

const UmpireRatings = ({
    umpire,
    year,
}: UmpireRatingsProps): React.JSX.Element => {
    const currentYear = useAppSelector(state =>
        selectSetting(state, "umphub_current_league_year"),
    );
    const sectionTitle =
        year === "current"
            ? `Current Year (${currentYear?.setting})`
            : "Past Years";
    const yearData = year === "current" ? "currentYear" : "pastYears";
    const totalGames =
        umpire[yearData] &&
        umpire[yearData].MAJORYBL +
            umpire[yearData].WIBB +
            umpire[yearData].ILBB;

    return umpire[yearData] && totalGames !== 0 ? (
        <Table className={classNames("umpireData")}>
            <tbody>
                <tr>
                    <th scope="row" colSpan={2}>
                        <b>{sectionTitle}</b>
                    </th>
                </tr>
                <tr>
                    <th scope="row">Games Umped</th>
                    <td>
                        <b>Total Games</b>: {totalGames}
                        <br />
                        <b>WI:</b> {umpire[yearData].WIBB} <br />
                        <b>IL:</b> {umpire[yearData].ILBB} <br />
                        <b>MAJORYBL:</b> {umpire[yearData].MAJORYBL}
                    </td>
                </tr>
                <tr>
                    <th scope="row">Ratings</th>
                    <td>
                        <b>Attitude:</b> {umpire[yearData].attitude}
                        <br />
                        <b>Consistency:</b> {umpire[yearData].consistency}
                        <br />
                        <b>Effort:</b> {umpire[yearData].effort}
                        <br />
                        <b>Overall:</b> {umpire[yearData].overall}
                        <br />
                    </td>
                </tr>
                <tr>
                    <th scope="row">Total Ratings</th>
                    <td>{umpire[yearData].totalRatings}</td>
                </tr>
            </tbody>
        </Table>
    ) : (
        <></>
    );
};

export default UmpireRatings;
